"use client";
import {
  useFormGroup
} from "../__chunks/3AAZQSAV.js";
import "../__chunks/ULCTMK2H.js";
import "../__chunks/3X3MDQGM.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/LFJDOMBA.js";
import "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/2SMRF6AD.js";

// src/form/form-radio-group.ts
var useFormRadioGroup = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = __spreadValues({ role: "radiogroup" }, props);
    props = useFormGroup(props);
    return props;
  }
);
var FormRadioGroup = createComponent(
  (props) => {
    const htmlProps = useFormRadioGroup(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  FormRadioGroup.displayName = "FormRadioGroup";
}
export {
  FormRadioGroup,
  useFormRadioGroup
};
